// ─── Alert Context ────────────────────────────────────────────
import { createContext, useCallback, useContext, useState } from "react";
import { WarningAlert } from "../../../../../components/alerts/warningAlert";
import { ErrorAlert } from "../../../../../components/alerts/errorAlert";
import { InfoAlert } from "../../../../../components/alerts/infoAlert";
import { useMobileDetection } from "../../../../../hooks/use-mobile-detection";

const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
  const [messsageAlert, setMessageAlert] = useState("");
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [isOpenInfo, setIsOpenInfo] = useState(false);
  const { isDesktop } = useMobileDetection();

  const showAlert = useCallback((type, message, duration = 6000) => {
    setMessageAlert(message);
    setAlertSession(true);

    if (type === "warning") setIsOpenWarning(true);
    if (type === "error") setIsOpenError(true);
    if (type === "info") setIsOpenInfo(true);

    setTimeout(() => {
      setMessageAlert("");
      setAlertSession(false);
      setIsOpenWarning(false);
      setIsOpenError(false);
      setIsOpenInfo(false);
    }, duration);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {alertSession && (
        <>
          <WarningAlert
            isOpen={isOpenWarning}
            message={messsageAlert}
            isDesktop={isDesktop}
          />
          <ErrorAlert
            isOpen={isOpenError}
            message={messsageAlert}
            isDesktop={isDesktop}
          />
          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          />
        </>
      )}
      {children}
    </AlertContext.Provider>
  );
};

// Hook para usar en cualquier step
export const useAlert = () => useContext(AlertContext);
